import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  logged: false,
  refreshToken: null,
  accessToken: null,
  idToken: null,
  user: {},
  loading: true,
};

const adminSessionSlice = createSlice({
  name: 'adminSession',
  initialState,
  reducers: {
    adminSessionActive: (state, { payload }) => {
      const { refreshToken, accessToken, idToken, user } = payload;

      return {
        ...state,
        logged: true,
        refreshToken,
        accessToken,
        idToken,
        user,
        loading: false,
      };
    },
    adminSessionInactive: state => ({
      ...state,
      ...initialState,
      loading: false,
    }),
  },
});

export const { adminSessionActive, adminSessionInactive } = adminSessionSlice.actions;
export default adminSessionSlice.reducer;
